import * as React from 'react';
import styled from 'styled-components'
import {ConstBorderRound, ConstColor, ConstFontStyle, ConstPadding} from "../../../../config/styles_const/styles_const";
import Select, {Props} from 'react-select'

interface IProps
    extends Props
{
}

const SelectMultiDefault: React.FC<IProps> = (props) => {

    const { children, ...SelectProps } = props;

    return (
        <Select classNamePrefix={'select'}  {...SelectProps}>
            {children}
        </Select>
    )

};

const FormMultiSelect = styled(SelectMultiDefault)`
    // font
    font-style: normal;
    font-weight: ${ConstFontStyle.FormDefault.fontWeight};
    font-size: ${ConstFontStyle.FormDefault.fontSize};
    line-height: ${ConstFontStyle.FormDefault.lineHeight};
    color: ${ConstColor.Base};
    
    & .select__control {
        background-color: ${ConstColor.White};
        // border
        border: 1px solid ${ConstColor.Gray};
        border-radius: ${ConstBorderRound.CornerRoundAll};
    }
    & .select__control--is-focused {
        outline: 0;
        border: 1px solid ${ConstColor.Focus};
        box-shadow: none;
    }
    & .select__control--is-focused:hover {
        border-color: ${ConstColor.Focus};
    }
    
    & .select__value-container {
       padding: ${ConstPadding.FormDefaultPadding};
    }
    & .select__placeholder {
        color: ${ConstColor.PlaceholderAndBorder};
    }

    
`;

export default FormMultiSelect;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/form/form_multi_select.tsx